import * as React from 'react';

const RocketIcon = () => (
  <svg
    width="25"
    height="24"
    viewBox="0 0 25 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M9.6415 17.3034C8.58084 20.4854 4.3382 20.4854 4.3382 20.4854C4.3382 20.4854 4.3382 16.2428 7.52018 15.1821"
      stroke="inherit"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M19.1876 9.87888L12.8236 16.2428L8.58099 12.0002L14.9449 5.63624C17.3547 3.22648 19.7645 3.24998 20.7922 3.40332C20.9504 3.4269 21.0969 3.5007 21.21 3.61382C21.3231 3.72695 21.3969 3.87342 21.4205 4.03165C21.5738 5.05935 21.5973 7.46912 19.1876 9.87888Z"
      stroke="inherit"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M18.1268 10.9395V16.9928C18.1268 17.0912 18.1074 17.1888 18.0697 17.2798C18.0321 17.3708 17.9768 17.4534 17.9072 17.5231L14.8751 20.5551C14.7791 20.6511 14.6589 20.7193 14.5272 20.7523C14.3955 20.7853 14.2574 20.782 14.1275 20.7426C13.9975 20.7033 13.8807 20.6294 13.7895 20.5289C13.6982 20.4284 13.636 20.305 13.6094 20.1719L12.8235 16.2428"
      stroke="inherit"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M13.8841 6.69678H7.8308C7.73231 6.69678 7.63478 6.71618 7.54379 6.75387C7.45279 6.79156 7.37011 6.8468 7.30047 6.91645L4.26843 9.94849C4.17244 10.0445 4.1043 10.1647 4.07128 10.2964C4.03826 10.4281 4.0416 10.5662 4.08094 10.6962C4.12028 10.8261 4.19414 10.9429 4.29465 11.0341C4.39517 11.1254 4.51856 11.1876 4.65167 11.2143L8.5808 12.0001"
      stroke="inherit"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default RocketIcon;
